import { AbaPQEscopoMultiplosGestores, deletePqMultiplosGestores } from '@app/api/contrato/contratoBase';
import { ContratoPlanilhaQuantidadeAtual, getAllPlanilhaQuantidadeMultiplosGestoresAtual, getExportarPqAtualMultiplosGestores, updateTipoDocumentoCobranca } from '@app/api/contrato/planilhaQuantidadeContrato';
import { Visibility } from '@app/components/Visibility';
import { hasPermission } from '@app/helpers/permissions';
import { Button, FormSelect, MasterDetailForm, Table, usePromise, Widget } from '@digital/ui';
import { Select, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import ModalAdicionaEscopoPQ from './ModalAdicionaEscopoPQ';

interface Props {
  multiplosGestoresEscopo: AbaPQEscopoMultiplosGestores[];
  pqMultiplosGesotresEscopo: AbaPQEscopoMultiplosGestores;
  selectedItem: any;
  getPQMultiplosGestores: () => void;
  isConsolidado: boolean;
  tipoDocumentoCobranca: any;
}

const { Option } = Select;

const WidgetPQMultiplosGestores = (props: Props) => {
  const { multiplosGestoresEscopo, pqMultiplosGesotresEscopo, selectedItem, getPQMultiplosGestores, isConsolidado, tipoDocumentoCobranca } = props;
  const [itemAdded, setItemAdded] = useState(false);
  const [btnExpandirAtual, setBtnExpandirAtual] = useState(true);
  const [PqRowExpandedAtual, setPqRowExpandedAtual] = useState(['']);
  const [PqExpandableRowsAtual, setPqExpandableRowsAtual] = useState(['']);
  const [hasAcaoAprovarPq, setAcaoAprovarPq] = useState(false);
  const [hasAcaoCorrigoPq, setAcaoCorrigoPq] = useState(false);
  const [hasAcaoReprovarPq, setAcaoReprovarPq] = useState(false);
  const [hasAcaoAjustarPq, sethasAcaoAjustarPq] = useState(false);
  const [hasAtualizarGridPrincipal, sethasAtualizarGridPrincipal] = useState(false);

  useEffect(() => {
    if (!btnExpandirAtual) setPqRowExpandedAtual(PqExpandableRowsAtual);
    else setPqRowExpandedAtual([]);
  }, [btnExpandirAtual, PqExpandableRowsAtual]);

  const handleEditLinhaPq = (id: any, value: any) => {
    updateTipoDocumentoCobranca(id, value).then(data => {
      if (data) {
        if (data) {
          setItemAdded(!itemAdded);
          setItemAdded(!itemAdded);
        }
      }
    });
  };
  
  const calculateDefaultExpandedRowKeys = (data: ContratoPlanilhaQuantidadeAtual[]) => {
    let keys: string[] = [];
    const mapRowKeys = (source: ContratoPlanilhaQuantidadeAtual[]) => {
      source.forEach(element => {
        if (element.children.length !== 0) {
          mapRowKeys(element.children);
          keys.push(element.id);
        }
      });
    };
    mapRowKeys(data);
    return keys;
  };
  
  const deletePqMultiplosGestor = () => {
    deletePqMultiplosGestores(selectedItem.id, pqMultiplosGesotresEscopo.idPq).then(data => {
      if(data){
        getPQMultiplosGestores();
      }
    })
  }

  const PlanilhaQuantidadeColumns = [
    {
      title: (
        <div style={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}>
          <Tooltip title={btnExpandirAtual ? 'Expandir todos' : 'Colapsar todos'}>
            <div
              className={`ant-table-row-expand-icon ${
                btnExpandirAtual ? 'ant-table-row-collapsed' : 'ant-table-row-expanded'
              }`}
              style={{ marginRight: 8 }}
              onClick={() => setBtnExpandirAtual(!btnExpandirAtual)}
            />
          </Tooltip>
          Item
        </div>
      ),
      dataIndex: 'codigoItem',
      editable: { inputType: 'text' },
      width: '15%',
    },
    {
      title: 'Descrição',
      dataIndex: 'descricao',
      editable: { inputType: 'text' },
      width: '36%',
    },
    {
      title: 'DOC. COBRANÇA',
      dataIndex: 'tipoDocumentoCobrancaId',
      render: (text, record, index) => {
        return (
          <MasterDetailForm key="selectDocCobranca">
            <FormSelect
              disabled={(!hasPermission(['CONTRATO_PQ_CADASTRAR', 'CONTRATO_PQ_AJUSTAR', 'CONTRATO_PQ_AJUSTAR']) || !isConsolidado)}
              options={tipoDocumentoCobranca ? tipoDocumentoCobranca : undefined}
              value={ (record.tipoDocumentoCobrancaId)  ? record.tipoDocumentoCobrancaId : undefined}
              name={`documentoCobranca-${record.id}`}
              onChange={e => handleEditLinhaPq(record.id, e)}
            />
          </MasterDetailForm>
        );
      },
      width: '10%',
    },
    {
      title: 'Unidade',
      dataIndex: 'unidade',
      editable: { inputType: 'text' },
      width: '5%',
    },
    {
      title: 'Quantidade',
      dataIndex: 'quantidade',
      editable: { inputType: 'number' },
      width: '10%',
    },
    {
      title: 'Preço unitário',
      dataIndex: 'precoUnitario',
      editable: { inputType: 'text' },
      width: '17%',
    },
    {
      title: 'Valor Total',
      dataIndex: 'valorTotal',
      editable: { inputType: 'text' },
      width: '17%',
    },
  ];

  const [getAllplanilhaQuantidade] = usePromise(
    () =>
      selectedItem
        ? getAllPlanilhaQuantidadeMultiplosGestoresAtual(selectedItem.id, pqMultiplosGesotresEscopo.identificador).then(data => {
          if (data) {
            if (PqExpandableRowsAtual[0] === '')
              setPqExpandableRowsAtual(calculateDefaultExpandedRowKeys(data as ContratoPlanilhaQuantidadeAtual[]));
          }
          return data as ContratoPlanilhaQuantidadeAtual[];
        })
        : Promise.resolve(undefined),
    [
      itemAdded,
      hasAcaoAprovarPq,
      hasAcaoReprovarPq,
      hasAcaoCorrigoPq,
      hasAcaoAjustarPq,
      selectedItem,
      hasAtualizarGridPrincipal,
    ],
    [],
  );
  
  return (
    <>
      <Widget actions={[
        <Button
          onClick={() => {
            setBtnExpandirAtual(!btnExpandirAtual);
          }}
          name="btnExpandirPqAtual"
          title={btnExpandirAtual ? 'Expandir' : 'Contrair'}
          type="link"
        />,
        <Button
          type="link"
          icon="files-xls"
          onClick={() => {
            getExportarPqAtualMultiplosGestores(selectedItem.id,pqMultiplosGesotresEscopo.identificador);
          }}>
          Exportar PQ atual
        </Button>,
        <Visibility visible={!isConsolidado}>
          <Button
            type="danger"
            onClick={() => {
              deletePqMultiplosGestor();
            }}>
            Cancelar PQ
          </Button>
        </Visibility>,
        <Visibility
          visible={hasPermission(['SGC_CONTRATO_VIZUALIZAR_TODAS_SEÇOES_PQ_ASSOCIADAS'])}
        >
          <ModalAdicionaEscopoPQ
            multiplosGestoresEscopo={multiplosGestoresEscopo}
            GetPQMultiplosGestores={getPQMultiplosGestores}
            isNew={false}
            actualValues={{
              identificador: pqMultiplosGesotresEscopo.identificador,
              escopo: pqMultiplosGesotresEscopo.escopo
            }}
          />
        </Visibility>
      ]}>
        <Table
          className="multiple-level-table on-table-fixed-overflow"
          columns={PlanilhaQuantidadeColumns}
          dataSource={getAllplanilhaQuantidade}
          pagination={false}
          expandedRowKeys={PqRowExpandedAtual}
          rowKey={'id'}
          expandIcon={props => {
            const expanded = !props.record.children.length
              ? 'ant-table-row-spaced'
              : props.expanded
                ? 'ant-table-row-expanded'
                : 'ant-table-row-collapsed';
            return (
              <div
                className={`ant-table-row-expand-icon ${expanded}`}
                onClick={e => {
                  if (PqRowExpandedAtual.includes(props.record.id))
                    setPqRowExpandedAtual(
                      PqRowExpandedAtual.filter(element => element !== props.record.id),
                    );
                  else {
                    setPqRowExpandedAtual([...PqRowExpandedAtual, props.record.id]);
                  }
                  props.onExpand(props.record, e);
                }}
              />
            );
          }}
        />
      </Widget>
    </>
  );
};
export default WidgetPQMultiplosGestores;
